import { useCallback, useEffect } from "react";

const LOCK_SCROLL_CLASS = "lock-scroll";

const updateElsClassList = (
  els,
  type
) => {
  for (const el of els) {
    if (el) {
      el.classList[type](LOCK_SCROLL_CLASS);
    }
  }
};

export const useLockBodyScrollCustom = (isLocked) => {
  const getEls = useCallback(
    () => [
      document.documentElement,
      document.body,
    ],
    []
  );

  useEffect(() => {
    if (isLocked) {
      updateElsClassList(getEls(), "add");
    } else {
      updateElsClassList(getEls(), "remove");
    }

    return () => {
      updateElsClassList(getEls(), "remove");
    };
  }, [getEls, isLocked]);

  return {
    isLocked,
  };
};
